<template>
  <div class="c-navigation-bar" :class="{ transparent: transparent }">
    <div class="c-navigation-bar-wrap">
      <el-button type="primary" size="small" icon="el-icon-back" v-if="hasBack" @click="handleBack">返回</el-button>
      <div class="navigation-title">{{ title }}</div>
      <!-- <el-page-header @back="$router.back()" :title="title" :content="content"></el-page-header> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    hasBack: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
    },
    content: {
      type: String,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    onBack: {
      type: Function,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    async handleBack() {
      if (this.onBack) {
        await this.onBack();
      }
      this.$router.back();
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
};
</script>
<style lang="scss" scoped>
.c-navigation-bar {
  display: flex;
  position: relative;
  box-sizing: border-box;
  margin: -16px 0 20px;

  &-wrap {
    flex: 1;
    display: flex;
    position: relative;
    box-sizing: border-box;
    padding: 16px 0 16px;
    border-bottom: 1px solid #e9ecf3;
  }
  .navigation-title {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-right: 76px;
    font-size: 16px;
    font-weight: 700;
    color: #333333;
  }
  &.transparent {
    margin: 0;
    padding: 0 24px;
    // border-bottom: none;
    background-color: #ffffff;
    .c-navigation-bar-wrap {
    }
  }
}
</style>
